import styled from '@emotion/styled';

const StyledWrapper = styled.div({
  height: '100vh',
  display: 'flex',
  flexDirection: 'column'
});

export default StyledWrapper;
